import { render, staticRenderFns } from "./aipayment.vue?vue&type=template&id=20697899&scoped=true&"
import script from "./aipayment.vue?vue&type=script&lang=js&"
export * from "./aipayment.vue?vue&type=script&lang=js&"
import style0 from "./aipayment.vue?vue&type=style&index=0&id=20697899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20697899",
  null
  
)

export default component.exports